import { z } from 'zod';

const baseString = z.string().trim();

export const formatPhoneDisplay = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  const local =
    digits.length === 11 && digits.startsWith('1')
      ? digits.slice(1)
      : digits.slice(0, 10);

  if (local.length < 10) {
    return local;
  }

  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};

export const normalizeToE164 = (phone: string): string | null => {
  if (/^\+1[2-9]\d{9}$/.test(phone)) {
    return phone;
  }

  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10 && /^[2-9]/.test(digits)) {
    return `+1${digits}`;
  }

  if (
    digits.length === 11 &&
    digits.startsWith('1') &&
    /^1[2-9]/.test(digits)
  ) {
    return `+${digits}`;
  }

  return null;
};

export const formatPhoneHref = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  return digits;
};

export const PhoneValidationSchema = z
  .union([
    baseString.regex(
      /^(\+1\s?)?(\()?[2-9][0-9]{2}\)?[\s.-]?[2-9][0-9]{2}[\s.-]?[0-9]{4}$/,
      'Invalid phone number'
    ),
    baseString.regex(/^(\d{3}) (\d{3}) (\d{4})$/, 'Invalid phone number'),
    baseString.regex(/^\+1[2-9]\d{9}$/, 'Invalid phone number'),
    z.literal(''),
  ])
  .transform((val) => (val === '' ? '' : (normalizeToE164(val) ?? val)));
